import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { CustomTable } from "../../../../../../../components";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { getCurrency } from "../../../../../../../plugins/utils";
import { useHandlingFee } from "../../../../context/HandlingFeeContext";
import { useGetAgentFeeBetBonus } from "../../../../hooks/handlingfeereport.hooks";
import styles from "./style.module.scss";

const CURRENCY = getCurrency();

const BettingRecord = ({}) => {
  const { t } = useTranslation();
  const { selectedMonth } = useHandlingFee();

  const { data, isLoading, isError, error } = useGetAgentFeeBetBonus({
    params: {
      period_month: selectedMonth.value,
    },
    options: {
      enabled: selectedMonth !== null,
    },
  });

  const columns = [
    {
      title: t("comission.table.account"),
      width: 100,
      align: "center",
      dataIndex: "account",
    },
    {
      title: t("comission.table.UID"),
      width: 100,
      align: "center",
      dataIndex: "account_id",
    },
    {
      title: `${t("handlingFee.table.bettingamount")} (${t(`global.currency.${CURRENCY}`)})`,
      align: "center",
      width: 100,
      dataIndex: "sum_bet_amount",
      search: false,
      render: (text, record, index) => (
        <div className={`${styles.amount} ${text <= 0 ? styles.redColor : styles.greenColor}`}>
          {moneyFormat(text)}
        </div>
      ),
    },
  ];

  return (
    <div className={styles.container}>
      {isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={data?.game_bet || []}
          showInifineScroll={false}
          summary={() => {
            return (
              <Table.Summary fixed="top">
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    <div className={styles.summaryCell}>{t("normal.summary")}</div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} />
                  <Table.Summary.Cell index={2}>
                    <div
                      className={`${styles.summaryCell} ${styles.content} ${
                        data?.total_bet <= 0 ? styles.redColor : styles.greenColor
                      }`}
                    >
                      {moneyFormat(data?.total_bet || 0)}
                    </div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} />
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      )}
    </div>
  );
};

export default BettingRecord;
